<template>

    <div class="disconnect__container">

        <div v-if="showBan"
             class="disconnect"
             :class="{
             disconnect__red: itISOffline,
             disconnect__green: itISOnline
         }">

            <p class="disconnect__text">{{ computedText }}</p>

            <img src="/img/icons/check-circle-white.svg" class="disconnect__img" v-if="itISOnline">

            <svg class="disconnect__img" v-if="itISOffline" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path fill="#fff"
                      d="M6.447 13.642h4.93l-2.581 6.881c-.365.947.622 1.453 1.253.681l7.953-9.753c.157-.191.232-.374.232-.581 0-.366-.282-.631-.664-.631h-4.93l2.58-6.882c.366-.946-.622-1.444-1.253-.68L6.015 12.43c-.15.191-.232.374-.232.581 0 .366.282.631.664.631z"/>
            </svg>

        </div>

<!--        <img src="/img/icons/check-circle-white.svg" class="disconnect__img" v-if="isOffline">-->
        <svg class="disconnect__img" v-if="isOffline" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path fill="#fff" d="M6.447 13.642h4.93l-2.581 6.881c-.365.947.622 1.453 1.253.681l7.953-9.753c.157-.191.232-.374.232-.581 0-.366-.282-.631-.664-.631h-4.93l2.58-6.882c.366-.946-.622-1.444-1.253-.68L6.015 12.43c-.15.191-.232.374-.232.581 0 .366.282.631.664.631z"/>
        </svg>


    </div>

</template>

<script>

import Vuex from 'vuex'

export default {

    name: 'disconnect-bar',

    computed: {

        ...Vuex.mapGetters([
            'internet'
        ]),

        computedText () {
            return this.itISOnline ? this.$t('global_connected') : this.$t('global_disconnected')
        },

        showBan () {
            return this.itISOffline || this.showTemporarily
        },

        itISOnline () {

            return !this.itISOffline
        },

        itISOffline () {

            return this.isOffline || !this.internet
        }

    },

    data () {
        return {
            showTemporarily: false
        }
    },

    mounted () {

        this.$on('online', () => {

            this.showTemporarily = true
            setTimeout(()=> {
                this.showTemporarily = false
            }, 3000)
        })

    }

}
</script>

<style scoped lang="scss">

    .disconnect {
        width: 100%;
        height: 32px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        position: fixed;
        left: 0;
        right: 0;
        bottom: 55px;
        padding: 0 8px;

        &__container {
            width: 100%;
            position: relative;
            @media screen and (min-width: $above-tablet-length) {
                display: flex;
                justify-content: center;
                position: fixed;
                bottom: 10px;
                left: 320px;
                right: 0;
                width: auto;
            }
        }

        &__red {
            background-color: $raspberry;
        }

        &__green {
            background-color: $lime;
        }

        &__text {
            font-size: 13px;
            font-weight: 600;
            line-height: 1.23;
            color: $white;
        }

        &__img {
            width: 24px;
            object-fit: contain;
        }

        @media screen and (min-width: $above-tablet-length) {
            position: absolute;
            width: 480px;
            height: 40px;
            border-radius: 16px;
            bottom: 40px;
            left: auto;
            right: auto;
        }
    }
</style>
